export default "__VITE_ASSET__CKMWqZWd__"